import { useTranslation as useReactI18nTranslation } from 'react-i18next'
import { useLanguageStore } from '@/store/languageStore'

interface TranslationOptions {
  defaultValue?: string
  [key: string]: any
}

export function useTranslation(ns?: string | string[]) {
  // Get the full hook result from react-i18next which handles language reactivity
  const { t: originalT, i18n, ...rest } = useReactI18nTranslation(ns)
  const { debugMode } = useLanguageStore()

  const t = (key: string, options?: string | TranslationOptions): string => {
    // In debug mode, show the translation key instead of the translated value
    if (debugMode) {
      return `[${key}]`
    }
    const result = originalT(key, options as any)
    // console.log(`🔤 t('${key}') => '${result}' (lang: ${i18n?.language})`);
    return String(result)
  }

  return {
    t,
    i18n,
    ...rest,
  }
}

export default useTranslation
